var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3053_36343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 30H20.1468V10C14.9904 10.1147 10.0746 12.2552 6.41724 15.9783C2.75992 19.7014 0.641259 24.7218 0.5 30Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3122 17.8925C34.4877 15.4767 32.1551 13.5127 29.4875 12.1464C26.82 10.78 23.886 10.0464 20.9036 10V29.6281L34.6574 19.1942L36.3122 17.8925Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7664 18.5125L21.6301 30H40.4999C40.4296 25.8705 39.1267 21.8619 36.7664 18.5125Z",
    fill: "#0069D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3053_36343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.00292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfPie);
export default __webpack_public_path__ + "static/media/half_pie.04835b07fab2b738e21ce9547cf8c137.svg";
export { ForwardRef as ReactComponent };